export default __webpack_public_path__ + "static/media/xcel.b4a36bfe.svg";